import { TabListFieldsFragment } from "@src/generated/graphql";
import { highlightBracketedText } from "src/utils/utils";
import React from "react";
import { DynamicLink } from "src/components/shared";
import { FaArrowRightLong } from "react-icons/fa6";

type OurApproachComponentProps = {
  content: TabListFieldsFragment;
};

const PartnerTablist = ({ content }: any) => {
  const { title, tabsCollection } = content;
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);
   
  return (
    <div className="partner-ecosystem">
      <div className="partner-ecosystem__container">
        <div className="partner-ecosystem__header">
          <h1
            className="partner-ecosystem__title"
            dangerouslySetInnerHTML={{
              __html: highlightBracketedText(title ?? "", "bold"),
            }}
          />
        </div>

        <div className="partner-ecosystem__tabs">
          <div className="partner-ecosystem__tabs-wrapper">
            {tabsCollection?.items.map((tab, index) => {
              if (!tab) return null;
              // Add active class by default to the first tab
              const isActive = activeTabIndex === index;
              return (
                <button
                  key={tab.sys.id || index}
                  onClick={() => setActiveTabIndex(index)}
                  className={`partner-ecosystem__tab-button ${isActive ? "active" : ""}`}
                  style={
                    {
                      "--scaleX": isActive ? "1" : "0",
                    } as React.CSSProperties
                  }
                >
                  {tab.tabTitle || "Untitled"}
                </button>
              );
            })}
          </div>
        </div>

        {tabsCollection?.items.map((tab, index) => {
          if (!tab || activeTabIndex !== index) return null;

          return (
            <div
              key={tab.sys.id || index}
              className="partner-ecosystem__content"
            >
              <span
                className="partner-ecosystem__category-label font-medium"
                style={{
                  color: `#${tab.colour}`
                }}
              >
                {tab.tabTitle}
              </span>

              {tab.tabDescription?.json?.content?.[0]?.content?.[0]?.value && (
                <h2
                  className="partner-ecosystem__content-title"
                  style={{ color: "#131327" }}
                >
                  {tab.tabDescription.json.content[0].content[0].value}
                </h2>
              )}
              {tab.tabSubDescription?.json?.content?.[0]?.content?.[0]
                ?.value && (
                <p
                  className="partner-ecosystem__content-description"
                  style={{ color: "#131327" }}
                >
                  {tab.tabSubDescription.json.content[0].content[0].value}
                </p>
              )}

              <div className="partner-ecosystem__features">
                {tab.infoItemsCollection?.items.map((infoItem, itemIndex) => {
                  if (!infoItem) return null;
                  return (
                    <div
                      key={infoItem.sys.id || itemIndex}
                      className="partner-feature"
                    >
                      <div
                        className="partner-feature__icon"
                       
                      >
                        <img
                          src={infoItem?.icon?.url ?? ""}
                          alt={infoItem?.icon?.title ?? ""}
                        />
                      </div>
                      <h3
                        className="partner-feature__title font-medium"
                        style={{ color: "#131327" }}
                      >
                        {infoItem.itemText || ""}
                      </h3>
                      <p
                        className="partner-feature__description"
                        style={{ color: "#131327" }}
                      >
                        {infoItem.additionalItemText || ""}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <DynamicLink url={content?.linkButton?.buttonLink} className="btn-default-bdr">
                  <span>{content?.linkButton?.buttonText}</span>
                  <FaArrowRightLong className="btn-icon" />
                </DynamicLink>
              </div>
            </div>
          );
        })}

        <div></div>
      </div>
    </div>
  );
};

export default PartnerTablist;
